// ชื่อ feature_code ต้องตรงกับฝั่ง BE (src/config/billingPlans.js) เป๊ะ
//
// ไม่มี DF_CORRECTION โดยตั้งใจ — การแก้ DF ไม่ใช่ฟีเจอร์ที่ขาย แต่เป็นกติกา
// ปิดงวดบัญชีที่ใช้กับทุกคลินิกเท่ากัน บังคับที่ BE
// (df_correction_service/correctionWindow.js) ห้ามเพิ่มกลับเข้ามา
export const FEATURE = {
  STORAGE: "STORAGE",
  DISCOUNT_TEMPLATE: "DISCOUNT_TEMPLATE",
  PATIENT_GROUP: "PATIENT_GROUP",
  DOCUMENT_GENERATOR: "DOCUMENT_GENERATOR",
  DENTCARE_REMINDER: "DENTCARE_REMINDER",
  DENTCARE_CHATBOT: "DENTCARE_CHATBOT",
  MCP_TOOL_CALL: "MCP_TOOL_CALL",
  AD_FREE: "AD_FREE",
};

// เฉพาะ feature code ที่ธงเดิม (isFileStorageExpired) เคยคุมอยู่จริงก่อนมี
// entitlements API — เส้นทางถอยของโค้ดกลุ่มนี้เท่านั้นที่ใช้ธงเดิม
// (!isFileStorageExpired) ได้ เพราะมันคือพฤติกรรมวันนี้ของฟีเจอร์เหล่านี้จริงๆ
//
// ห้ามเพิ่ม feature code ใหม่เข้าลิสต์นี้ ต่อให้ดูเหมือนลืมใส่ก็ตาม — ฟีเจอร์ที่
// เพิ่งเกิดทีหลังธงเดิม (เช่น AD_FREE, DENTCARE_REMINDER, DENTCARE_CHATBOT,
// MCP_TOOL_CALL) ไม่เคยถูกธงเดิมคุม ถ้าเผลอถอยไปใช้ธงเดิมให้มันจะกลายเป็นแจก
// สิทธิ์ที่ลูกค้าไม่เคยซื้อให้ทุกสาขาที่มี subscription เดิม (regression เงียบๆ)
export const LEGACY_GATED = [
  FEATURE.STORAGE,
  FEATURE.DISCOUNT_TEMPLATE,
  FEATURE.PATIENT_GROUP,
  FEATURE.DOCUMENT_GENERATOR,
];

// ใช้เฉพาะตอนที่ยังไม่มีข้อมูลจาก API และธงเดิมบอกว่าไม่มี subscription
// ต้องตรงกับค่า FREE ของ BE เพื่อให้เส้นทางถอยให้คำตอบเดิมกับวันนี้
//
// DISCOUNT_TEMPLATE และ PATIENT_GROUP อยู่ใน LEGACY_GATED ด้วย แต่ค่าตรงนี้ไม่ใช่
// ของค้าง — entitlementLimit (stores/branch.js) ใช้ค่านี้เป็นคำตอบตอน "ไม่มี
// subscription" อยู่แล้ววันนี้ แม้ code จะยังอยู่ใน LEGACY_GATED ก็ตาม และเมื่อ
// LEGACY_GATED เล็กลงหรือหายไปในเฟสที่ถอด isFileStorageExpired ทิ้ง ค่าเดียวกันนี้
// จะกลายเป็นคำตอบของ code เหล่านี้ทั้งสองสถานะ (ไม่ใช่แค่ตอนไม่มี subscription
// อีกต่อไป) — ใช้งานอยู่แล้ววันนี้ และจะใช้งานมากขึ้นทีหลัง ไม่ใช่ dead code
export const FREE_LIMITS = {
  [FEATURE.DISCOUNT_TEMPLATE]: 5,
  [FEATURE.PATIENT_GROUP]: 5,
};

// ค่า FREE ของฟีเจอร์แบบเปิด/ปิด (ไม่ใช่โควตาตัวเลข) — ใช้เป็นเส้นทางถอยของ
// feature code ที่ไม่อยู่ใน LEGACY_GATED (ธงเดิมไม่เคยคุม) เมื่อไม่มีข้อมูลจาก
// entitlements API เลย ทุกค่าเป็น false วันนี้ เพราะฟีเจอร์กลุ่มนี้ไม่เคยมีมา
// ก่อน จึงไม่มี "พฤติกรรมเดิม" ให้ต้องรักษาไว้ — ปิดไว้ก่อนคือค่าที่ปลอดภัยสุด
//
// DOCUMENT_GENERATOR อยู่ใน LEGACY_GATED ด้วย ต่างจาก FREE_LIMITS ด้านบน —
// ตรงนี้อ่านไม่ถึงจริงๆ วันนี้ (entitlementFlag กิ่ง LEGACY_GATED คืน
// !isFileStorageExpired ตรงๆ ไม่แตะ FREE_FLAGS เลย) แต่ไม่ใช่ของค้างที่ลบทิ้งได้
// — นี่คือจุดลงจอด: เมื่อ LEGACY_GATED เล็กลงหรือหายไปในเฟสที่ถอด
// isFileStorageExpired ทิ้ง code นี้จะตกไปอยู่กิ่งเดียวกับ code อื่นทันที และค่า
// false ตรงนี้คือสิ่งเดียวที่กันไม่ให้สาขาที่ไม่มี subscription ได้ฟีเจอร์นี้ไป
// ฟรีๆ ตอนนั้น ห้ามลบเพราะดูเหมือนอ่านไม่ถึง — อ่านไม่ถึง "ตอนนี้" คือจุดประสงค์
// ของมัน ไม่ใช่ความผิดพลาด
export const FREE_FLAGS = {
  [FEATURE.DOCUMENT_GENERATOR]: false,
  [FEATURE.DENTCARE_REMINDER]: false,
  [FEATURE.DENTCARE_CHATBOT]: false,
  [FEATURE.MCP_TOOL_CALL]: false,
  [FEATURE.AD_FREE]: false,
};
